// extracted by mini-css-extract-plugin
module.exports = {"component":"media-slider-controls_component__EkQrc","button":"media-slider-controls_button__J_R0q"};